/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Media Blog API
 * API сервиса статей (MVP).
 * OpenAPI spec version: 1.12.0
 */
import { fetcher } from '../../../utils/fetcher';
import type {
  EntitySearchResult,
  GetV1Search400,
  GetV1Search500,
  GetV1SearchParams,
} from '../../models';

/**
 * Full-text search with filters (booleans are tri-state: omit param to ignore)
 * @summary Search articles
 */
export type getV1SearchResponse200 = {
  data: EntitySearchResult;
  status: 200;
};

export type getV1SearchResponse400 = {
  data: GetV1Search400;
  status: 400;
};

export type getV1SearchResponse500 = {
  data: GetV1Search500;
  status: 500;
};

export type getV1SearchResponseComposite =
  | getV1SearchResponse200
  | getV1SearchResponse400
  | getV1SearchResponse500;

export type getV1SearchResponse = getV1SearchResponseComposite & {
  headers: Headers;
};

export const getGetV1SearchUrl = (params?: GetV1SearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/search?${stringifiedParams}`
    : `/v1/search`;
};

export const getV1Search = async (
  params?: GetV1SearchParams,
  options?: RequestInit
): Promise<getV1SearchResponse> => {
  return fetcher<getV1SearchResponse>(getGetV1SearchUrl(params), {
    ...options,
    method: 'GET',
  });
};
